import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from '@/locales/fr.json';
import en from '@/locales/en.json';
import ar from '@/locales/ar.json';
import arOverrides from '@/locales/ar-overrides.json';
import privatePagesFr from '@/locales/private-pages-fr.json';
import privatePagesEn from '@/locales/private-pages-en.json';
import privatePagesAr from '@/locales/private-pages-ar.json';
import localeFillFr from '@/locales/locale-fill-fr.json';
import localeFillEn from '@/locales/locale-fill-en.json';
import localeFillAr from '@/locales/locale-fill-ar.json';
import {
  ERROR_CATALOG_FR,
  ERROR_CATALOG_EN,
  ERROR_CATALOG_AR,
} from '@/lib/i18n/errorCatalog';
import { deepMerge } from '@/lib/i18n/mergeTranslations';

const frMerged = deepMerge(
  deepMerge(
    deepMerge(fr as Record<string, unknown>, ERROR_CATALOG_FR),
    privatePagesFr as Record<string, unknown>
  ),
  localeFillFr as Record<string, unknown>
);
const enMerged = deepMerge(
  deepMerge(
    deepMerge(en as Record<string, unknown>, ERROR_CATALOG_EN),
    privatePagesEn as Record<string, unknown>
  ),
  localeFillEn as Record<string, unknown>
);
const arMerged = deepMerge(
  deepMerge(
    deepMerge(
      deepMerge(ar as Record<string, unknown>, ERROR_CATALOG_AR),
      privatePagesAr as Record<string, unknown>
    ),
    arOverrides as Record<string, unknown>
  ),
  localeFillAr as Record<string, unknown>
);

// Détection : 1) choix utilisateur (persisté), 2) langue du navigateur si supportée, sinon français.
// Ne pas fixer `lng` dans init : sinon la détection (navigator) est ignorée au premier chargement.
const detectionOptions = {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage'],
  lookupLocalStorage: 'i18nextLng',
  checkWhitelist: true,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: frMerged },
      en: { translation: enMerged },
      ar: { translation: arMerged },
    },
    fallbackLng: {
      ar: ['ar'],
      en: ['en', 'fr'],
      fr: ['fr'],
      default: ['fr'],
    },
    supportedLngs: ['fr', 'en', 'ar'],
    detection: detectionOptions,
    
    interpolation: {
      escapeValue: false, // React protège déjà contre XSS
    },
  });

// Gestion de la direction RTL pour l'arabe
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  
  // Ajouter une classe spécifique au body pour faciliter le styling CSS spécifique si nécessaire
  if (lng === 'ar') {
    document.body.classList.add('rtl');
    document.body.classList.remove('ltr');
  } else {
    document.body.classList.add('ltr');
    document.body.classList.remove('rtl');
  }
});

export default i18n;
